import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/siteData";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.06 } },
};
const item = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
};

export const Services = () => {
  const go = () => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="services" data-testid="services" className="py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400 mb-4">What we fix & install</p>
            <h2 className="font-display font-extrabold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl">
              Full-service plumbing,<br /><span className="brand-gradient-text">done properly.</span>
            </h2>
          </div>
          <p className="text-base md:text-lg text-neutral-600 max-w-sm">
            From a single fixture to a whole heating system — pick what you need and we'll take it from there.
          </p>
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-4"
        >
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.id}
                variants={item}
                data-testid={`service-${s.id}`}
                onClick={go}
                className={`group text-left relative rounded-3xl border-2 border-[#111111] bg-[#FEBE10] p-7 md:p-8 overflow-hidden transition-colors duration-300 hover:border-black ${s.span || ""}`}
              >
                <div className="relative flex items-start justify-between">
                  <div className="h-16 w-16 rounded-2xl bg-[#111111] border-2 border-black flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                    <Icon className="h-8 w-8 text-[#FEBE10]" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-neutral-300 group-hover:text-[#007AFF] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                </div>
                <h3 className="relative mt-6 text-2xl font-display font-bold tracking-tight text-[#111111]">{s.title}</h3>
                <p className="relative mt-2 text-2xl leading-relaxed text-[#111111]">{s.blurb}</p>
              </motion.button>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
